// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4471de56","598":"bb2f73df","703":"c3f96f33"}[chunkId] + ".chunk.js";
};